/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormElementSubSectionDto } from './FormElementSubSectionDto';
import {
    FormElementSubSectionDtoFromJSON,
    FormElementSubSectionDtoFromJSONTyped,
    FormElementSubSectionDtoToJSON,
    FormElementSubSectionDtoToJSONTyped,
} from './FormElementSubSectionDto';

/**
 * 
 * @export
 * @interface FormElementSectionDto
 */
export interface FormElementSectionDto {
    /**
     * 
     * @type {string}
     * @memberof FormElementSectionDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FormElementSectionDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof FormElementSectionDto
     */
    shortTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof FormElementSectionDto
     */
    description?: string;
    /**
     * 
     * @type {Array<FormElementSubSectionDto>}
     * @memberof FormElementSectionDto
     */
    formElementSubSections: Array<FormElementSubSectionDto>;
    /**
     * 
     * @type {string}
     * @memberof FormElementSectionDto
     */
    applicationFormId?: string | null;
    /**
     * If true, this section is a template for spawning
     * @type {boolean}
     * @memberof FormElementSectionDto
     */
    isTemplate?: boolean;
    /**
     * Unique reference key for this template section
     * @type {string}
     * @memberof FormElementSectionDto
     */
    templateReference?: string;
    /**
     * Title template with placeholder (e.g., "Modul{{triggerValue}}")
     * @type {string}
     * @memberof FormElementSectionDto
     */
    titleTemplate?: string;
    /**
     * Reference of the form element that triggered this section
     * @type {string}
     * @memberof FormElementSectionDto
     */
    spawnedFromElementReference?: string;
    /**
     * If true, this section is deferred while the form is in its trial period.
     * @type {boolean}
     * @memberof FormElementSectionDto
     */
    deferredDuringTrial?: boolean;
}

/**
 * Check if a given object implements the FormElementSectionDto interface.
 */
export function instanceOfFormElementSectionDto(value: object): value is FormElementSectionDto {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('formElementSubSections' in value) || value['formElementSubSections'] === undefined) return false;
    return true;
}

export function FormElementSectionDtoFromJSON(json: any): FormElementSectionDto {
    return FormElementSectionDtoFromJSONTyped(json, false);
}

export function FormElementSectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormElementSectionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'],
        'shortTitle': json['shortTitle'] == null ? undefined : json['shortTitle'],
        'description': json['description'] == null ? undefined : json['description'],
        'formElementSubSections': ((json['formElementSubSections'] as Array<any>).map(FormElementSubSectionDtoFromJSON)),
        'applicationFormId': json['applicationFormId'] == null ? undefined : json['applicationFormId'],
        'isTemplate': json['isTemplate'] == null ? undefined : json['isTemplate'],
        'templateReference': json['templateReference'] == null ? undefined : json['templateReference'],
        'titleTemplate': json['titleTemplate'] == null ? undefined : json['titleTemplate'],
        'spawnedFromElementReference': json['spawnedFromElementReference'] == null ? undefined : json['spawnedFromElementReference'],
        'deferredDuringTrial': json['deferredDuringTrial'] == null ? undefined : json['deferredDuringTrial'],
    };
}

export function FormElementSectionDtoToJSON(json: any): FormElementSectionDto {
    return FormElementSectionDtoToJSONTyped(json, false);
}

export function FormElementSectionDtoToJSONTyped(value?: FormElementSectionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'shortTitle': value['shortTitle'],
        'description': value['description'],
        'formElementSubSections': ((value['formElementSubSections'] as Array<any>).map(FormElementSubSectionDtoToJSON)),
        'applicationFormId': value['applicationFormId'],
        'isTemplate': value['isTemplate'],
        'templateReference': value['templateReference'],
        'titleTemplate': value['titleTemplate'],
        'spawnedFromElementReference': value['spawnedFromElementReference'],
        'deferredDuringTrial': value['deferredDuringTrial'],
    };
}

